import React from "react";

import { Survey } from "@/components/survey/Survey";
import QuestionSets from "@/components/survey/questionSets/questionSets";
import { useGoto } from "@/hooks";

export const ScaleOptInView: React.FC = () => {
  const goto = useGoto();

  const onSurveyComplete = async () => {
    goto.openApp();
  };

  return (
    <Survey
      baseRoute="/scale-opt-in"
      onSurveyComplete={onSurveyComplete}
      questionSet={QuestionSets.SCALE_OPT_IN_SURVEY}
    />
  );
};
